/* Cup size quiz (sections/md-cup-quiz.liquid) */
(function () {
  var STORE_KEY = 'mdq:v2';

  var SIZES = {
    small: { name: 'Small', short: 'S' },
    large: { name: 'Large', short: 'L' }
  };

  var LABELS = {
    age: { under18: 'Under 18', '18-24': '18 to 24', '25-34': '25 to 34', '35plus': '35 or older' },
    marital: { unmarried: 'Unmarried', married: 'Married' },
    birth: { none: 'No births', csection: 'C-section', vaginal: 'Vaginal delivery' },
    flow: { light: 'Light flow', normal: 'Normal flow', heavy: 'Heavy flow' },
    first: { yes: 'First cup', no: 'Used a cup before' }
  };

  var SWATCH = { pink: '#f2a7c3', purple: '#9b6bc4', black: '#1f1f24', white: '#ffffff', clear: '#e9eef2', blue: '#7fa8e0' };

  /* Two sizes only: Large after a vaginal delivery, Small for everyone else.
     Age and marital status only change the wording. */
  function recommend(a) {
    if (a.age === 'under18') {
      return { size: 'small', text: "Since you're under 18, your pelvic muscles are naturally tighter, so the Small cup is the most comfortable fit." };
    }
    if (a.birth === 'vaginal') {
      return { size: 'large', text: "Because you've had a vaginal delivery, the Large size gives you the best comfort and fit." };
    }
    if (a.birth === 'csection') {
      return { size: 'small', text: "Since you've had a C-section, your pelvic muscles usually stay tighter, so the Small size is ideal." };
    }
    if (a.marital === 'married') {
      return { size: 'small', text: "You're married with no childbirth, so the Small cup gives you the best comfort and protection." };
    }
    return { size: 'small', text: "With no childbirth, your pelvic muscles are usually firm, so the Small cup gives you the right comfort and flexibility." };
  }

  /* "Small" -> small, "Large" -> large; XS variants are never recommended */
  function sizeKey(value) {
    var v = String(value || '').toLowerCase();
    if (/\bxs\b|extra\s*small/.test(v)) return 'xs';
    if (/small/.test(v)) return 'small';
    if (/large/.test(v)) return 'large';
    return '';
  }

  function load() {
    try { return JSON.parse(window.localStorage.getItem(STORE_KEY)) || null; } catch (e) { return null; }
  }
  function save(data) {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  }

  function init(root) {
    if (root.dataset.mdqReady) return;
    root.dataset.mdqReady = '1';

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var screens = {};
    [].forEach.call(root.querySelectorAll('[data-screen]'), function (el) { screens[el.dataset.screen] = el; });
    var questions = [].slice.call(root.querySelectorAll('[data-q]'));
    var stepLabel = root.querySelector('[data-step-label]');
    var bars = [].slice.call(root.querySelectorAll('.mdq__progress span'));
    var template = root.querySelector('[data-card-template]');
    var grid = root.querySelector('[data-grid]');

    var products = [];
    try { products = JSON.parse(root.querySelector('[data-mdq-products]').textContent) || []; } catch (e) {}

    var answers = {};
    var current = 0;
    var advanceTimer = null;

    /* Under 18 always gets Small, so the private questions are skipped.
       Flow and first cup don't change the size; they are saved on the order. */
    function flow() {
      return answers.age === 'under18'
        ? ['age', 'flow', 'first']
        : ['age', 'flow', 'first', 'marital', 'birth'];
    }

    function show(name, focusEl) {
      Object.keys(screens).forEach(function (k) {
        var el = screens[k];
        var on = k === name;
        el.hidden = !on;
        el.classList.toggle('is-in', on);
      });
      var top = root.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.4) {
        var header = document.querySelector('.header-sticky, sticky-header');
        var offset = header ? header.getBoundingClientRect().height : 0;
        window.scrollTo({ top: window.pageYOffset + top - offset - 12, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (focusEl) focusEl.focus({ preventScroll: true });
    }

    function renderQuestion(index, dir) {
      current = index;
      var steps = flow();
      var key = steps[index];
      questions.forEach(function (q) {
        var on = q.dataset.q === key;
        q.hidden = !on;
        q.classList.remove('is-fwd', 'is-back');
        if (on && !reduceMotion) {
          void q.offsetWidth;
          q.classList.add(dir === 'back' ? 'is-back' : 'is-fwd');
        }
        if (on) {
          [].forEach.call(q.querySelectorAll('.mdq__opt'), function (b) {
            var sel = answers[key] === b.dataset.value;
            b.classList.toggle('is-selected', sel);
            b.setAttribute('aria-pressed', sel ? 'true' : 'false');
          });
        }
      });
      stepLabel.textContent = 'Question ' + (index + 1) + ' of ' + steps.length;
      bars.forEach(function (b, i) {
        b.hidden = i >= steps.length;
        b.classList.toggle('is-done', i <= index);
      });
      var title = root.querySelector('[data-q="' + key + '"] .mdq__q-title');
      if (screens.quiz.hidden) {
        show('quiz', title);
      } else {
        title.focus({ preventScroll: true });
      }
    }

    function pick(btn) {
      var q = btn.closest('[data-q]');
      var key = q.dataset.q;
      answers[key] = btn.dataset.value;
      [].forEach.call(q.querySelectorAll('.mdq__opt'), function (b) {
        var sel = b === btn;
        b.classList.toggle('is-selected', sel);
        b.setAttribute('aria-pressed', sel ? 'true' : 'false');
      });
      clearTimeout(advanceTimer);
      advanceTimer = setTimeout(function () {
        var steps = flow();
        if (current + 1 < steps.length) {
          renderQuestion(current + 1, 'fwd');
        } else {
          finish();
        }
      }, reduceMotion ? 80 : 260);
    }

    function finish() {
      var rec = recommend(answers);
      save({ answers: answers, size: rec.size, at: Date.now() });
      track('cup_quiz_completed', { size: rec.size });
      renderResult(rec);
    }

    /* Cart attributes are copied onto the order ("Additional details" in admin),
       so support can see the quiz result and answers behind each order. */
    function saveToCart(rec) {
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var a = answers;
      var label = function (key) { return (LABELS[key] && LABELS[key][a[key]]) || 'Not asked'; };
      var d = new Date();
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      return fetch(base + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Quiz size': SIZES[rec.size].name,
            'Quiz age': label('age'),
            'Quiz marital status': label('marital'),
            'Quiz births': label('birth'),
            'Quiz flow': label('flow'),
            'Quiz first cup': label('first'),
            'Quiz date': d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate())
          }
        })
      }).catch(function () {});
    }

    var pendingSave = Promise.resolve();
    var lastRec = null;

    /* First-timer tips: only for "this will be my first cup" */
    function renderTips(rec) {
      var tips = root.querySelector('[data-tips]');
      var jump = root.querySelector('[data-tips-jump]');
      if (!tips) return;
      var first = answers.first === 'yes';
      tips.hidden = !first;
      if (jump) jump.hidden = !first;
      var wa = tips.querySelector('[data-wa]');
      if (wa && first) {
        var text = 'Hi MomDaughts, the size quiz recommended ' + SIZES[rec.size].name +
          ' for me and this will be my first cup. Can you help me get started?';
        wa.href = 'https://wa.me/' + wa.dataset.wa + '?text=' + encodeURIComponent(text);
      }
    }

    function renderResult(rec) {
      lastRec = rec;
      pendingSave = saveToCart(rec);
      renderTips(rec);
      var size = SIZES[rec.size];
      root.querySelector('[data-size-short]').textContent = size.short;
      root.querySelector('[data-size-name]').textContent = size.name;
      root.querySelector('[data-explain]').textContent = rec.text;

      var chips = root.querySelector('[data-answers]');
      chips.innerHTML = '';
      flow().forEach(function (key) {
        var label = LABELS[key] && LABELS[key][answers[key]];
        if (!label) return;
        var li = document.createElement('li');
        li.className = 'mdq__chip';
        li.textContent = label;
        chips.appendChild(li);
      });

      var cards = buildCards(rec.size);
      grid.innerHTML = '';
      cards.forEach(function (c) { grid.appendChild(c); });
      grid.classList.toggle('is-single', cards.length === 1);
      root.querySelector('[data-empty]').hidden = cards.length > 0;
      var n = cards.length;
      root.querySelector('[data-picks-title]').textContent = n === 1
        ? 'Comes in ' + size.name
        : n + ' cups come in ' + size.name;

      show('result', root.querySelector('[data-size-name]'));
    }

    function buildCards(size) {
      var list = [];
      products.forEach(function (p) {
        if (!p.sizePos) return;
        var matches = p.variants.filter(function (v) { return sizeKey(v.options[p.sizePos - 1]) === size; });
        if (!matches.length) return;
        list.push({ p: p, variants: matches });
      });
      /* Always the order set in the theme editor (Double Tail, then Long Tail, ...) */
      return list.map(function (item) { return card(item.p, item.variants, size); });
    }

    function card(p, variants, size) {
      var node = template.content.firstElementChild.cloneNode(true);
      var img = node.querySelector('[data-img]');
      var price = node.querySelector('[data-price]');
      var compare = node.querySelector('[data-compare]');
      var add = node.querySelector('[data-add]');
      var msg = node.querySelector('[data-msg]');
      var swatches = node.querySelector('[data-swatches]');
      var links = node.querySelectorAll('[data-link]');
      var selected = variants.filter(function (v) { return v.available; })[0] || variants[0];

      node.querySelector('[data-title]').textContent = p.title;

      function select(v) {
        selected = v;
        if (v.img) { img.src = v.img; img.alt = v.alt || p.title; }
        price.innerHTML = v.price;
        compare.hidden = !v.compare;
        if (v.compare) compare.innerHTML = v.compare;
        var url = p.url + (p.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id;
        [].forEach.call(links, function (a) { a.href = url; });
        add.disabled = !v.available;
        add.textContent = v.available ? 'Add to cart' : 'Sold out';
        msg.hidden = true;
        [].forEach.call(swatches.children, function (s) {
          var on = s.dataset.id == v.id;
          s.classList.toggle('is-selected', on);
          s.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      if (p.colorPos && variants.length > 1) {
        swatches.setAttribute('aria-label', 'Colour');
        variants.forEach(function (v) {
          var color = v.options[p.colorPos - 1];
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'mdq__swatch' + (v.available ? '' : ' is-out');
          b.dataset.id = v.id;
          b.title = color + (v.available ? '' : ' (sold out)');
          b.innerHTML = '<span class="mdq__swatch-dot" aria-hidden="true"></span><span class="mdq__swatch-label"></span>';
          b.querySelector('.mdq__swatch-dot').style.background = SWATCH[String(color).toLowerCase()] || '#d8d4e4';
          b.querySelector('.mdq__swatch-label').textContent = color;
          b.setAttribute('aria-label', color + (v.available ? '' : ', sold out'));
          b.addEventListener('click', function () { select(v); });
          swatches.appendChild(b);
        });
      } else {
        swatches.remove();
      }

      add.addEventListener('click', function () { addToCart(selected, add, msg); });
      select(selected);
      return node;
    }

    function addToCart(variant, btn, msg) {
      if (!variant || !variant.available || btn.disabled) return;
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var label = btn.textContent;
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.textContent = 'Adding…';
      msg.hidden = true;

      /* Wait for the quiz attributes so a brand-new cart isn't created twice */
      pendingSave.then(function () {
        return fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });
      }).then(function (res) {
        return res.json().then(function (body) { return { ok: res.ok, body: body }; });
      }).then(function (r) {
        if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || 'Could not add to cart.');
        track('cup_quiz_add_to_cart', { variant_id: variant.id });
        if (lastRec) pendingSave = saveToCart(lastRec);
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          /* cart-drawer re-renders itself, updates the header count and opens */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        } else {
          window.location.href = base + 'cart';
        }
        setTimeout(function () {
          btn.textContent = label;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 2200);
      }).catch(function (err) {
        msg.textContent = err.message;
        msg.hidden = false;
        btn.textContent = label;
        btn.disabled = false;
      }).then(function () {
        btn.classList.remove('is-loading');
      });
    }

    /* Events */
    root.querySelector('[data-start]').addEventListener('click', function () {
      answers = {};
      track('cup_quiz_started', {});
      renderQuestion(0, 'fwd');
    });

    root.querySelector('[data-back]').addEventListener('click', function () {
      clearTimeout(advanceTimer);
      if (current === 0) {
        show('intro', root.querySelector('[data-start]'));
      } else {
        renderQuestion(current - 1, 'back');
      }
    });

    [].forEach.call(root.querySelectorAll('.mdq__opt'), function (btn) {
      btn.addEventListener('click', function () { pick(btn); });
    });

    root.querySelector('[data-edit]').addEventListener('click', function () {
      renderQuestion(0, 'back');
    });

    root.querySelector('[data-restart]').addEventListener('click', function () {
      answers = {};
      renderQuestion(0, 'fwd');
    });

    /* Returning visitor: offer the last result */
    var saved = load();
    var resume = root.querySelector('[data-resume]');
    if (saved && saved.answers && SIZES[saved.size]) {
      resume.querySelector('[data-resume-size]').textContent = SIZES[saved.size].name;
      resume.hidden = false;
      resume.addEventListener('click', function () {
        answers = saved.answers;
        renderResult(recommend(answers));
      });
    }
  }

  function boot(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-mdq]'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
